export const IconScale = {
    tiny: {
        width: '12px',
        height: '12px',
    },
    mini: {
        width: '16px',
        height: '16px',
    },
    xsmall: {
        width: '18px',
        height: '18px',
    },
    small: {
        width: '24px',
        height: '24px',
    },
    base: {
        width: '24px',
        height: '24px',
    },
    medium: {
        width: '32px',
        height: '32px',
    },
    large: {
        width: '48px',
        height: '48px',
    },
    xlarge: {
        width: '64px',
        height: '64px',
    },
    xxlarge: {
        width: '96px',
        height: '96px',
    },
    xxxlarge: {
        width: '128px',
        height: '128px',
    },
};
